import { useEffect, useState } from "react";

/**
 * 订阅 prefers-reduced-motion。SSR 安全(window 守卫),监听 change 实时更新。
 * 全站动效原语单一真相源;wecom-h5 旧路径 re-export 到此。
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () =>
      typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const on = () => setReduced(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return reduced;
}
